export default function upperCase(string) {
  if (typeof string !== "string") return;
  return string.toUpperCase();
}
